module.exports = __webpack_public_path__ + "static/media/DooTech.e98c2c6d.svg";